<template>
  <div>
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <CustomersCard
          v-for="item of items"
          :id="item.id"
          :key="item.id"
          :name="item.name"
          :customers="item.customers"
          :status="{ text: item.isActive, color: item.isActive ? 'green' : 'red' }"
          @clickOnOrder="onClickRow({ id: item.id })"
        />
      </div>
      <div v-else>{{ $t("page.dashboard.emptyMessage") }}</div>
    </template>

    <OurTable v-else :headers="headers" :items="items" :table-fixed="false"> </OurTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomersCard from "@/components/MobileCards/CustomersCard.vue";
import { buildFocusGroupListTableHeaders } from "@/views/settings/focus-group/index/config/focusGroupListTableHeaders";

export default {
  name: "FocusGroupList",
  components: { CustomersCard },

  props: {
    items: {
      type: Array,
      default: () => [],
    },

    headers: {
      type: Array,
      default: null,
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    resolvedTableHeaders() {
      if (this.headers) {
        return this.headers;
      }

      return buildFocusGroupListTableHeaders({
        t: (key) => this.$t(key),
      });
    },
  },

  methods: {
    onClickRow(row) {
      this.$emit("onClickRow", row.id);
    },
  },
};
</script>
